import React, { useEffect, useState } from "react";
import { PaginatedItems } from "../../components/customComponents/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Spinner } from "react-bootstrap";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import carroIcono from "../../assets/img/icono-carro2.png";
import motoIcono from "../../assets/img/moto2.png";
import { RegistrarEditarEventoRobo } from "../../components/customComponents/Modals/RegistrarEditarEventoRobo";
import { useUnidades } from "../../hooks/test/useUnidades";
import useCeo from "../../hooks/useCEO";

export const SwatRegistrosBoletinados = () => {

    useCeo({
        title: "Eventos boletinados",
        description: "Eventos boletinados",
    });

    const [actiModal, setActiModal] = useState(false);
    const [event, setEvent] = useState(false);
    const [search, setSearch] = useState("");
    const [idUnidad, setIdUnidad] = useState();
    const [tipoUnidadId, setTipoUnidadId] = useState();
    const [eventoSeguridadId, setEventoSeguridadId] = useState();
    const [regBoletinados, setRegBoletinados] = useState([]);
    const [loading, setLoading] = useState(false);
    const { getRegistrosBoletinados } = useUnidades();

    useEffect(() => {
        reloatUnits();
    }, []);

    const reloatUnits = async () => {
        setLoading(true);
        let resp = await getRegistrosBoletinados();
        if (resp.ok) setRegBoletinados(resp.registros);
        setLoading(false);
        if (!resp.ok) setRegBoletinados([]);
    }

    const handleChangeSearch = e => {
        setSearch(e.target.value);
    }

    const modalClose = async () => {
        setActiModal(false);
        await reloatUnits();
    } 

    let results = !search ? regBoletinados :
        (
            regBoletinados ? regBoletinados.filter((elemento) => elemento.folio.toString().toLowerCase().includes(search.toLowerCase())) : ""
        );

    return (
        <>
            {loading && <Spinner />}
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-4 mt-4 inputWithIcon">
                        <input
                            className="form-control selectCedis"
                            placeholder="BUSCAR FOLIO"
                            name="palabra"
                            value={search}
                            onChange={handleChangeSearch}
                        ></input>
                        <button style={{ padding: "10px" }}>
                            <FontAwesomeIcon icon={faMagnifyingGlass} />
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <PaginatedItems
                            itemsPerPage={5}
                            currentPage={2}
                            items={
                                results.map((x, index) => {
                                    return (
                                        <>
                                            <div
                                                className="row unidad-element cursor animated delay-01s my-3"
                                                key={x.unidad_id}
                                                onClick={() => {
                                                    setActiModal(true);
                                                    setIdUnidad(x.unidad_id);
                                                    setEvent("EDITAR");
                                                    setEventoSeguridadId(x.evento_seguridad_id);
                                                    setTipoUnidadId(x.tipo_unidad_id);
                                                }}
                                            >
                                                <div className="col-md-2 text-center pb-3 bordersLeftRounded" style={{ background: "rgb(245, 245, 245)" }}>
                                                    <div className="contenedorCarro-salida pt-3">
                                                        <img
                                                            src={ x.tipo_unidad_id === 4 ? carroIcono : motoIcono}
                                                            alt="imagen"
                                                            className="img-fluid"
                                                            style={{ inlineSize: "55px", maxWidth: "45%" }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-11 col-sm-9" style={{ margin: "auto" }}>
                                                    <div className="row">
                                                        <div className="col-5">
                                                            <h6>
                                                                <small>FOLIO: </small>
                                                                <b>{x.folio} </b>

                                                            </h6>
                                                        </div>
                                                        <div className="col-7">
                                                            <h6>
                                                                <small>UNIDAD VIN: </small>
                                                                <b>{x.unidad_vin} </b>

                                                            </h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                })
                            }
                        />
                        {
                            results.length === 0 ? (
                                <>
                                    <div className="row justify-content-center">
                                        <div className="col-4 mt-4" style={{ textAlign: "center" }}>
                                            <h3>¡Búsqueda sin resultados! </h3>
                                        </div>
                                    </div>
                                </>
                            )
                                : ""
                        }

                    </div>
                </div>
            </div>

            {
                actiModal ?
                    <RegistrarEditarEventoRobo
                        idUnidad={idUnidad}
                        mostrarModal={actiModal}
                        onAction={modalClose}
                        tipo_unidad_id={tipoUnidadId}
                        eventAction={event}
                        viajeId={eventoSeguridadId}
                        evtBoletinado={true}
                    /> : ""
            }
        </>
    );
}